import React, { useEffect, useState } from 'react';
import IconButton from '@mui/material/IconButton';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';
import CameraAltIcon from '@mui/icons-material/CameraAlt';

import AddCircleIcon from '@mui/icons-material/AddCircle';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';

import { aws_base_path } from '../../../config/config';
import { MENU_ITEM_CATEGORY_LABELS } from '../../../constants';

export default function MenuItem(props) {

  const [itemQuantity, setItemQuantity] = useState(0);
  const [openImageDialog, setOpenImageDialog] = useState(false);

  function handleAddItem() {
    const count = itemQuantity + 1;
    props.onMenuItemQuantityChange({menuItemId: props.item.id, count: count})
    setItemQuantity(count);
  }

  function handleRemoveItem() {
    if (itemQuantity > 0) {
      const count = itemQuantity - 1;
      props.onMenuItemQuantityChange({menuItemId: props.item.id, count: count})
      setItemQuantity(count);
    }
  }

  const handleOpenImageDialog = () => {
    setOpenImageDialog(true);
  };

  const handleCloseImageDialog = () => {
    setOpenImageDialog(false);
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', alignContent: 'space-between', color: 'gray', gap: 8 }}>
      <div style={{flex: '1 1 auto', display:'flex', gap: 16, alignItems: 'center', minWidth: 0}}>
        <span style={{ wordWrap: 'break-word', overflowWrap: 'break-word' }}>{props.item.name}</span>
        <span style={{ fontSize: 18, whiteSpace: 'nowrap'}}>${props.item.price}</span>
        <IconButton 
          size="small" 
          onClick={handleOpenImageDialog}
          data-testid="image-preview-button"
          title="View image"
        >
          <CameraAltIcon />
        </IconButton>
      </div>
      
      <div style={{flex: '0 0 auto', textAlign: 'right', whiteSpace: 'nowrap'}}>
        <IconButton 
          data-testid="btn-minus-id"
          color={itemQuantity === 0 ? 'inherit' : 'primary'}
          disabled={itemQuantity === 0}
          onClick={handleRemoveItem}>
          <RemoveCircleIcon />
        </IconButton>
        <span data-testid="counter-id" style={{ fontSize: 18, marginLeft: 8, marginRight: 8}}>{itemQuantity}</span>
        <IconButton 
          data-testid="btn-plus-id" 
          color="primary" 
          onClick={handleAddItem}>
          <AddCircleIcon />
        </IconButton>
      </div>

      <Dialog 
        open={openImageDialog} 
        onClose={handleCloseImageDialog}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          <div>{props.item.name}</div>
          <Typography variant="subtitle2" color="text.secondary">
            {props.item.timeToPrepare} minutes preparation
          </Typography>
        </DialogTitle>
        <DialogContent>
          <img 
            src={aws_base_path + props.item.itemPic} 
            alt={props.item.name} 
            style={{ width: '100%', borderRadius: 8, marginBottom: 24 }} 
          />
          
          {/* Item Details Section */}
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 24, marginTop: 16 }}>
            {/* Category */}
            {props.item.category && (
              <div>
                <Typography variant="overline" sx={{ color: 'text.secondary', fontWeight: 600, fontSize: '0.75rem', letterSpacing: 0.5 }}>
                  Category
                </Typography>
                <Typography variant="body2" sx={{ marginTop: 0.5, fontWeight: 500 }}>
                  {MENU_ITEM_CATEGORY_LABELS[props.item.category] || props.item.category}
                </Typography>
              </div>
            )}
          </div>

          {/* Ingredients */}
          {props.item.ingredients && (
            <div style={{ marginTop: 24 }}>
              <Typography variant="overline" sx={{ color: 'text.secondary', fontWeight: 600, fontSize: '0.75rem', letterSpacing: 0.5 }}>
                Ingredients
              </Typography>
              <Typography variant="body2" sx={{ marginTop: 0.5, lineHeight: 1.6, whiteSpace: 'pre-wrap' }}>
                {props.item.ingredients}
              </Typography>
            </div>
          )}

          {/* Description */}
          {props.item.description && (
            <div style={{ marginTop: 24 }}>
              <Typography variant="overline" sx={{ color: 'text.secondary', fontWeight: 600, fontSize: '0.75rem', letterSpacing: 0.5 }}>
                Description
              </Typography>
              <Typography variant="body2" sx={{ marginTop: 0.5, lineHeight: 1.6, whiteSpace: 'pre-wrap' }}>
                {props.item.description}
              </Typography>
            </div>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
}